module.exports = __webpack_public_path__ + "media/images/front/sp/dummy/ranking02-0abd0368db2cb751ac466bb41f5aa49f.jpg";